export enum StorageKeyEnum {
  VERSION = 'version',
  CONFIG = 'config',
  CLUSTERS = 'clusters',
  COLLECTIONS = 'collections',
  COLLECTION = 'collection',
  PLACES = 'places',
  PLACE = 'place',
  GUIDES = 'guides',
  GUIDE = 'guide',
  BOOKMARK_IDS = 'bookmark_ids',
  SELECTED_CLUSTER = 'selected-cluster',
  GDRP = 'gdrp',
  DESTINATION_ON_SLIDER = 'destinations-on-slider',
  IS_ERROR_SHOW = 'isErrorShow',
  EVENT = 'event',
  EVENTS = 'events',
  STATIC_PAGES = 'static-pages',
  STATIC_PAGE = 'static-page',
  PASSPORT = 'passport',
  PASSPORTS = 'passports',
  PASSPORT_CHECK_IN_INFO = 'passport-check-in-info',
  MAP_TYPE = 'map-type',

  // AUTH KEYS
  USER = 'user',
  TOKEN = 'token',
  PROFILE = 'profile',
  PLANS = 'plans',
}
